module.exports = __webpack_public_path__ + "static/egyptian-bedding-set-dusty-rose-4-9559ce4098030bddc8c730719f112e9a.png";